import React, { Component, Fragment } from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { connect } from 'react-redux';
import { openModal } from '../../actions/modals';
import { publicRequest } from '../../services/ApiService';
import AuthMethodsBlock from '../Auth/AuthMethodsBlock';
import AffiliateEmailSignInForm from '../Auth/AffiliateEmailSignInForm';

class AffiliateSignInModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      socials: null,
      isFormShowing: props.shouldOpenEmailFormAfterRecovery
        ? props.shouldOpenEmailFormAfterRecovery
        : false,
    };
  }

  componentDidMount() {
    publicRequest
      .getSettings()
      .then((response) => {
        if (response && response.items) {
          const { socials } = response.items;
          this.setState(() => ({ socials }));
        }
      })
      .catch(({ response }) => {
        console.log(response);
      });
  }

  handleFormShow = (bool) => {
    this.setState(() => ({
      isFormShowing: bool,
    }));
  };

  handleAffiliateSignUpModalProps = () => {
    const { connectHash } = this.props;
    if (connectHash) {
      return { connectHash };
    } else {
      return {};
    }
  };

  render() {
    const { socials, isFormShowing } = this.state;
    const { openModal, closeModal, shouldOpenEmailFormAfterRecovery } = this.props;

    return (
      <div className="auth-modal">
        <div className="auth-modal-innner">
          <button type="button" className="popup-close" onClick={closeModal}>
            <i className="icon-cross-rounded" />
          </button>
          <h2 className="auth-modal-title">
            <FormattedMessage id="affiliate.login.title" defaultMessage="Affiliate Login" />
          </h2>
          {isFormShowing ? (
            <AffiliateEmailSignInForm
              isRecoverySuccessMessageVisible={shouldOpenEmailFormAfterRecovery}
              clickBackButton={this.handleFormShow.bind(null, false)}
              openModal={openModal}
            />
          ) : (
            <Fragment>
              <p className="auth-modal-subtitle">
                <FormattedHTMLMessage
                  tag="span"
                  id="affiliate.login.socials.title"
                  defaultMessage="Sign in&nbsp;using social networks"
                />
              </p>
              {/* <AuthMethodsBlock socials={socials} click={this.handleFormShow.bind(null, true)} /> */}
              <p className="auth-modal-disclaimer">
                <FormattedHTMLMessage
                  id="affiliate.auth.disclaimer"
                  defaultMessage="Logging in&nbsp;via social networks, you accept our ToC"
                />
              </p>
            </Fragment>
          )}

          <div className="auth-modal-link">
            <p className="auth-modal-link-title">
              <FormattedHTMLMessage
                id="affiliate.auth.link.to_signup.title"
                defaultMessage="Don&rsquo;t have an&nbsp;account yet?"
              />
            </p>

            <button
              className="auth-modal-link-button btn btn-inline"
              onClick={() => openModal(this.handleAffiliateSignUpModalProps(), 'affiliateSignUp')}
            >
              <FormattedHTMLMessage
                id="affiliate.auth.link.to_signup.button"
                defaultMessage="Sign Up"
              />
            </button>

            {/* <div className="grecaptcha-disclaimer">
                          This site is protected by reCAPTCHA and the Google{' '}
                          <a target="_blank" href="https://policies.google.com/privacy">Privacy Policy</a> and{' '}
                          <a target="_blank" href="https://policies.google.com/terms">Terms of Service</a> apply.
                        </div> */}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  modals: state.modals,
});

const mapDispatchToProps = (dispatch) => ({
  openModal: (modalProps, modalType) => dispatch(openModal({ modalProps, modalType })),
});

export default connect(mapStateToProps, mapDispatchToProps)(AffiliateSignInModal);
